const initialState = {
    sender: true,
    recipient: true,
    subject: true,
    date: true,
    copy: false,
    hidden_copy: false
};

const columnsmail = (state = initialState, action) => {
    switch (action.type) {
      case 'CHANGE_COLUMNS_MAIL':
        return {
              sender: action.sender,
              recipient: action.recipient,
              subject: action.subject,
              date: action.date,
              copy: action.copy,
              hidden_copy: action.hidden_copy
          }
      default:
        return state
    }
  }
  
  export default columnsmail
